import React from "react";

import { ClientsImages } from "./MajorClient";

const ClientSlider = () => {
  

  return (
    <div className="clientSlider industries_serving " data-aos="fade-up">
      <div className="scrolling-container d-flex m-0">
        {[1, 2].map((index) => {
          return (            <div className="serving" key={index}>
              {ClientsImages.map((obj, index) => {
                return (
                  <div className="box" key={index}>
                    <div className="img_box">
                      <img src={obj.src} alt={obj.src} loading="lazy" />
                    </div>
                  </div>
                );
              })}
              {ClientsImages.map((obj, index) => {
                return (
                  <div className="box" key={index}>
                    <div className="img_box">
                      <img src={obj.src} alt={obj.src} loading="lazy" />
                    </div>
                  </div>
                );
              })}
              {ClientsImages.map((obj, index) => {
                return (
                  <div className="box" key={index}>
                    <div className="img_box">
                      <img src={obj.src} alt={obj.src} loading="lazy" />
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ClientSlider;
